/*
  Live search on the blog listing. Matching articles are shown first, in their
  own grid above the normal one; the normal grid carries on underneath with
  those same articles removed, so the page reads as matches followed by
  everything else — and the infinite scroll keeps working on the normal grid
  exactly as before.

  When a search finds nothing, blog-spell.js suggests a corrected spelling;
  if that finds articles, they are shown with a "Showing results for" line.

  Needs blog-common.js loaded first, and blog-spell.js for correction.
*/
(function () {
  var DEBOUNCE_MS = 250;
  var MIN_CHARS = 2;
  // Columns in the grid at its widest. Matches are shown in whole rows of this,
  // so the matches grid never ends on a half-empty row.
  var ROW = 3;

  function init(root) {
    var NeoBlog = window.NeoBlog;
    var input = root.querySelector('.blog-search__input');
    var form = root.querySelector('.blog-search__form');
    var status = root.querySelector('[data-blog-search-status]');
    var grid = document.querySelector('[data-blog-grid]');
    if (!NeoBlog || !input || !grid) return;

    var endpoint = root.dataset.predictiveUrl;
    var blogPath = root.dataset.blogUrl;
    var correction = root.querySelector('[data-blog-search-correction]');
    var spellConfig = {
      lib: root.dataset.spellLib,
      dict: root.dataset.spellDict,
      extra: (root.dataset.spellWords || '').split(/[\s,]+/)
    };
    // A term the visitor asked to search exactly as typed; not corrected again.
    var keepAsTyped = '';

    // A separate class, not .blog-articles: the infinite scroll binds to the
    // first .blog-articles on the page, and this grid sits above the real one.
    var matches = document.createElement('div');
    matches.className = 'blog-search-matches';
    matches.hidden = true;
    grid.parentNode.insertBefore(matches, grid);

    var matchPaths = {};
    var timer = null;
    var controller = null;

    function announce(message) {
      if (status) status.textContent = message;
    }

    // Hide, in the normal grid, whatever is already listed above it. Runs
    // again whenever the infinite scroll appends a page.
    function hideDuplicates() {
      var cards = grid.querySelectorAll('.blog-article');
      for (var i = 0; i < cards.length; i++) {
        var link = cards[i].querySelector('a[href]');
        var path = link ? NeoBlog.pathOf(link.getAttribute('href')) : '';
        cards[i].hidden = !!matchPaths[path];
      }
    }

    new MutationObserver(hideDuplicates).observe(grid, { childList: true });

    function restore() {
      matchPaths = {};
      matches.hidden = true;
      matches.innerHTML = '';
      grid.classList.remove('is-after-matches');
      hideDuplicates();
      showCorrection(null);
      announce('');
      NeoBlog.writeTerm('');
    }

    // "Showing results for beauty · Search instead for “bauty”"
    function showCorrection(corrected, original) {
      if (!correction) return;
      if (!corrected) {
        correction.hidden = true;
        correction.innerHTML = '';
        return;
      }
      correction.innerHTML =
        'Showing results for <strong>' + NeoBlog.escapeHtml(corrected) + '</strong>' +
        '<span aria-hidden="true"> · </span>' +
        '<button type="button" class="blog-search__instead">Search instead for &ldquo;' +
        NeoBlog.escapeHtml(original) + '&rdquo;</button>';
      correction.hidden = false;
      correction.querySelector('button').addEventListener('click', function () {
        keepAsTyped = original;
        search(original);
      });
    }

    // The first few cards in the normal grid that are not already matches.
    function nextFromGrid(count) {
      var picked = [];
      var cards = grid.querySelectorAll('.blog-article');
      for (var i = 0; i < cards.length && picked.length < count; i++) {
        var link = cards[i].querySelector('a[href]');
        var path = link ? NeoBlog.pathOf(link.getAttribute('href')) : '';
        if (path && !matchPaths[path]) picked.push({ node: cards[i], path: path });
      }
      return picked;
    }

    function show(articles, term, original) {
      // Whole rows only: 10 becomes 9, 7 becomes 6, 4 becomes 3. The matches
      // left over are not lost — they stay in the normal grid below.
      var shown = articles.length >= ROW
        ? articles.slice(0, articles.length - (articles.length % ROW))
        : articles;

      matchPaths = {};
      shown.forEach(function (article) {
        matchPaths[NeoBlog.pathOf(article.url)] = true;
      });

      matches.innerHTML = shown.length
        ? shown.map(NeoBlog.card).join('')
        : '<p class="blog-search__empty">No articles match &ldquo;' + NeoBlog.escapeHtml(term) + '&rdquo;.</p>';

      // One or two matches cannot be rounded down to a row, so the row is
      // completed with the articles that come next — the same ones the normal
      // grid would have shown there.
      if (shown.length > 0 && shown.length < ROW) {
        nextFromGrid(ROW - shown.length).forEach(function (item) {
          matchPaths[item.path] = true;
          matches.appendChild(item.node.cloneNode(true));
        });
      }

      matches.hidden = false;
      grid.classList.add('is-after-matches');
      hideDuplicates();

      showCorrection(original ? term : null, original);

      announce(
        (original ? 'Showing results for ' + term + '. ' : '') +
        (shown.length
          ? shown.length + (shown.length === 1 ? ' matching article' : ' matching articles') + ', shown first'
          : 'No matching articles')
      );
      // Carried to the article page, which puts related matches first too.
      NeoBlog.writeTerm(term);
    }

    function search(term) {
      // Abandon anything in flight, so a slow early response cannot land on
      // top of the results for what was typed after it.
      if (controller) controller.abort();
      controller = new AbortController();

      var signal = controller.signal;

      NeoBlog.searchArticles(endpoint, term, blogPath, signal)
        .then(function (articles) {
          if (articles.length || term === keepAsTyped || !window.NeoSpell) {
            return { articles: articles, term: term, original: null };
          }
          return correct(term, signal).then(function (fixed) {
            return fixed || { articles: [], term: term, original: null };
          });
        })
        .then(function (result) {
          if (signal.aborted) return;
          show(result.articles, result.term, result.original);
        })
        .catch(function (error) {
          if (error.name === 'AbortError') return;
          restore();
        });
    }

    // Tries the likely spellings together and keeps the first, in order of
    // likelihood, that actually finds articles — which is what picks "beauty"
    // over the dictionary's first guess, "batty".
    function correct(term, signal) {
      return window.NeoSpell.ready(spellConfig).then(
        function (spell) {
          var phrases = window.NeoSpell.candidates(spell, term, 4);
          if (!phrases.length) return null;
          return Promise.all(
            phrases.map(function (phrase) {
              return NeoBlog.searchArticles(endpoint, phrase, blogPath, signal).then(
                function (articles) { return { term: phrase, articles: articles }; },
                function () { return { term: phrase, articles: [] }; }
              );
            })
          ).then(function (results) {
            for (var i = 0; i < results.length; i++) {
              if (results[i].articles.length) {
                return { articles: results[i].articles, term: results[i].term, original: term };
              }
            }
            return null;
          });
        },
        // Dictionary unavailable: behave exactly as before, no correction.
        function () { return null; }
      );
    }

    function schedule() {
      var term = input.value.trim();
      clearTimeout(timer);

      if (term.length < MIN_CHARS) {
        if (controller) controller.abort();
        restore();
        return;
      }

      timer = setTimeout(function () {
        search(term);
      }, DEBOUNCE_MS);
    }

    // Start fetching the dictionary as soon as the visitor shows intent, so it
    // is ready by the time a search comes back empty.
    input.addEventListener('focus', function () {
      if (window.NeoSpell) window.NeoSpell.ready(spellConfig).catch(function () {});
    }, { once: true });

    input.addEventListener('input', function () {
      if (input.value.trim() !== keepAsTyped) keepAsTyped = '';
      schedule();
    });

    input.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        input.value = '';
        schedule();
      }
    });

    if (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        clearTimeout(timer);
        var term = input.value.trim();
        if (term.length >= MIN_CHARS) search(term);
        else restore();
      });
    }

    // The field is the source of truth: arriving with it empty clears any
    // search left over from earlier; arriving with a term (back button,
    // autofill) re-runs it.
    if (input.value.trim().length >= MIN_CHARS) schedule();
    else NeoBlog.writeTerm('');
  }

  document.querySelectorAll('[data-blog-search]').forEach(init);
})();
